"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DoorClosed = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var DoorClosed = function DoorClosed() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "M5.5 21H18.5V4.5C18.5 3.672 17.828 3 17 3H7C6.172 3 5.5 3.672 5.5 4.5V21Z",
    opacity: "0.4",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M20 21.75H4C3.586 21.75 3.25 21.414 3.25 21C3.25 20.586 3.586 20.25 4 20.25H20C20.414 20.25 20.75 20.586 20.75 21C20.75 21.414 20.414 21.75 20 21.75Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M15.02 13C14.468 13 14.015 12.552 14.015 12C14.015 11.448 14.457 11 15.01 11H15.02C15.572 11 16.02 11.448 16.02 12C16.02 12.552 15.572 13 15.02 13Z",
    fill: "currentColor"
  }));
};

exports.DoorClosed = DoorClosed;